<div class="component-content" [style.height.px]="[getViewHeight()]">
    <div class="grid">
        <div class="first">
            <table class="lc-table" mat-table [dataSource]="dataSource">

                <!-- Create date Column -->
                <ng-container matColumnDef="timeStamp">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.timeStamp | date:'shortDate'}} | {{element.timeStamp | date:'mediumTime'}} </td>
                </ng-container>
        
                <!-- Reference Column -->
                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef>Description</th>
                    <td mat-cell *matCellDef="let element"> {{element.message}} </td>
                </ng-container>
        
                <!-- Row shown when there is no matching data. -->
                 <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="2" *ngIf="dataSource.data">No data to display</td>
                </tr> 
        
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </div>
        <div class="second">
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
        </div>
    </div>
</div>